const { camelCase, forEach } = require('lodash');

/**
 * Service for managing settings.
 * Stores settings in the 'Settings' constant object in the format `settings.groupName.settingName`
 */
class SettingsService {
    constructor($q, restangular, settings) {
        this.$q = $q;
        this.api = restangular.all('Settings');
        this.settings = settings;
    }

    updateSettings(settings) {
        forEach(settings, setting => this._updateSetting(setting.Group, setting.Name, setting.Value));
    }

    _updateSetting(group, name, value) {
        group = camelCase(group);
        name = camelCase(name);

        this.settings[group] = this.settings[group] || {};
        this.settings[group][name] = value;
    }

    /**
     * Gets a promise to the value of the provided setting
     *
     * @deprecated Use 'settingsService.settings.groupName.settingName', or inject 'Settings' and use 'settings.groupName.settingName'
     */
    getSettingValue(group, name) {
        group = camelCase(group);
        name = camelCase(name);

        if (!(group in this.settings)) {
            return this.$q.reject(new Error(`Error getting setting ${group}-${name}. Setting group not found.`));
        }

        const groupSettings = this.settings[group];

        if (!(name in groupSettings)) {
            return this.$q.reject(new Error(`Error getting setting ${group}-${name}. Setting name not found.`));
        }

        return this.$q.when(groupSettings[name]);
    }

    /**
     * Invalidates and updates setting values
     */
    invalidate() {
        return this.api.doGET().then(settings => this.updateSettings(settings));
    }
}

SettingsService.$inject = ['$q', 'Restangular', 'Settings'];

module.exports = {
    SettingsService,
};



// WEBPACK FOOTER //
// ./src/common/settings/settings.service.js